module.exports = __webpack_public_path__ + "img/indoor-light.d08e6f83.png";